import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';
import { cancelarCuenta, validarIdentidad, validarPreguntas } from './datos.act';

const mapState = (state) => {
    return {
    	preguntaUno: state.miPerfil.preguntaUno,
		preguntaUnoText: state.miPerfil.preguntaUnoText,
		preguntaDos: state.miPerfil.preguntaDos,
		preguntaDosText: state.miPerfil.preguntaDosText,
		preguntas1: state.catalogos.objetoPregunta1,
		preguntas2: state.catalogos.objetoPregunta2,
		numCelOtp: state.miPerfil.numCelOtp,
		correoOtp: state.miPerfil.correoOtp,
		loadLocal: state.miPerfil.loadLocal,
		dispositivo: state.global.dispositivo
    };
}

const mapDispatch = (dispatch) => {
    return {
        setEncabezado: (msj) => {
            dispatch({ "type": "MI_PERFIL_SET_ENCABEZADO_ELIMINAR", "msj": msj});
        },
    	setMsj: (msj) => {
    		dispatch({ "type": "MI_PERFIL_SET_MSJ_ELIMINAR", "msj": msj});
    	},
    	pasoSiguiente: () => {
            dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_ELIMINAR"});
        },
        setCta: (valor) => {
        	dispatch({ "type": "MI_PERFIL_SET_CUENTA_BORRADA", "valor": valor});
        },
        reset: () => {
            dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_ELIMINAR" });
        },
        validarIdentidad: (preg) => {
        	dispatch(validarIdentidad(preg));	
        },
        cancelarIdentidad: () => {
        	dispatch({ "type": "CERRAR_DETALLE_MOVIL" });
        	dispatch({ "type": "IDENTIDAD_MOVIL_INVALIDA" });
        },
        cancelarCuenta: (preg) => {
        	dispatch(cancelarCuenta(preg));
        },
        setloadLocal: (val) => {
            dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", load: val });
        },
        validarPreguntas: (preg) => {
        	dispatch(validarPreguntas(preg));	
        },
        cancelarValidacion: () => {
        	dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CODIGO" });
        },
        addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		}
    }
}

class PasoDosEliminarCuenta extends React.Component {
    state = {
    	errorPregunta: false,
    	intentoPregunta: 1,
    	preguntaCambiarContrasena: this.props.preguntaUnoText,
		pId1: this.props.preguntaUno,
		pId2: this.props.preguntaDos,
		inputClass: "input-wrap ver-input",
		inputClass2: "input-wrap ver-input",
		inputActive: "",
		inputActive2: "",
		inputType: "password",
		inputType2: "password",
		respuestaCambiarContrasena1: "",
		respuestaCambiarContrasena2: "",
		errorPreguntaContrasena: false,
		errorPreguntaContrasena2: false,
		errorMsjPreguntaContrasena: "",
		errorMsjPreguntaContrasena2: ""
    }

    handleFocus = (event) => {
    	let id = event.target.id;
    	
    	if(id == "respuesta1"){
    		this.setState({inputActive: "input-active"});
	    	this.setState({errorPreguntaContrasena: false});
	    	this.setState({errorMsjPreguntaContrasena: ""});
    	}else {
    		this.setState({inputActive2: "input-active"});
	    	this.setState({errorPreguntaContrasena2: false});
	    	this.setState({errorMsjPreguntaContrasena2: ""});
    	}
    	
    }
	handleBlur = (event) => {
		let id = event.target.id;
		
		if(id == "respuesta1"){
			let valor = event.target.value;
			this.setState({inputActive: valor ? "input-active" : ""});
	        this.setState({respuestaCambiarContrasena: valor});
		}
		else{
			let valor = event.target.value;
			this.setState({inputActive2: valor ? "input-active" : ""});
	        this.setState({respuestaCambiarContrasena2: valor});
		}
		
	}
	toggleType = (event) => {
		let id = event.target.id;
		let type;
		switch(id) {
        	case "ojoPreguntaPass":
                type = this.state.inputType;
                this.setState({inputType: type == "password" ? "text" : "password"});
                this.setState({inputClass: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
                break;
            case "ojoPreguntaPass2":
                type = this.state.inputType2;
                this.setState({inputType2: type == "password" ? "text" : "password"});
                this.setState({inputClass2: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
                break;
        }
	}
	revisarPregunta = () => {
        let pregunta1 = this.props.preguntaUno;
        let pregunta2 = this.props.preguntaDos;
        let respuesta1 = this.refs.respuesta1.value;
        let respuesta2 = this.refs.respuesta2.value;
        let obj = {
            p1: pregunta1,
            p2: pregunta2,
            r1: respuesta1,
            r2: respuesta2
        }
        if(!respuesta1 || !respuesta2) {
            this.setState({errorPreguntaContrasena: true});
            this.setState({errorMsjPreguntaContrasena: "Campo requerido."});
            
            if (this.props.movil) {
            } else if(this.props.dp) {
            	this.props.addEvento("CampoRequerido-PreguntasDP");
            } else {
            	this.props.addEvento("CampoRequerido-EliminarCuenta");
            }
            
            return;
        }
        this.props.setloadLocal(true);
        
        if (this.props.movil) {
        	this.props.validarIdentidad(obj);
        } 
        else if(this.props.dp) {
        	obj.numero = this.props.numCelOtp;
        	obj.correo = this.props.correoOtp;
        	obj.dispositivo = this.props.dispositivo;
        	this.props.validarPreguntas(obj);
        	this.props.addEvento("Siguiente-PreguntasDP");
        }
        else {
        	obj.dispositivo = this.props.dispositivo;
        	this.props.cancelarCuenta(obj);
        	this.props.addEvento("Siguiente-EliminarCuenta");
        }
    }
    cancelar = () => {
    	this.refs.respuesta1.value = "";
    	this.refs.respuesta2.value = "";
    	this.props.reset();
        if (this.props.movil) {
        	this.props.cancelarIdentidad();
        	goTo("movil/polizas");
        	//window.location.href = "/#!/movil/polizas";
        }
        else if(this.props.dp){
        	this.props.cancelarValidacion();
        	this.props.addEvento("Cancelar-PreguntasDP");
        	 $("#modal-codigo-dp").modal("toggle");
        }
        else{
        	$("#modal-eliminar-cuenta").modal("toggle");
        }
    }
    
    componentWillMount = () => {
        this.props.setloadLocal(false);
    }
	
	render() {
		return <div>
			{ !this.props.movil && !this.props.dp &&
        	<h5>
				<i>
					<img src={ require("../img/trash.png") } />
				</i>Petición para eliminar cuenta
			</h5>
			}
			{ this.props.movil &&
        	<h5>
				<i>
					<img src={ require("../img/user1.svg") } />
				</i>Validación de cuenta
			</h5>
			}
			{ this.props.dp &&
        	<h5>
				<i>
					<img src={ require("../img/user1.svg") } />
				</i>Autorización de modificación
			</h5>
			}
			{ this.state.errorPregunta && 
				<div className="msj-warning">
					<i className="no-pad"><img src={ require("../img/exclamation-naranja.png") } /></i>
					<span>
						Tu respuesta no coincide con tu pregunta secreta, por favor intenta nuevamente.
					</span>
				</div>
			}
			<hr className="mt-34" />
			{ this.props.loadLocal &&
            <div className="table-center">
				<img src={ require("../img/load_mini.gif") } />
            </div>
            }
            { !this.props.loadLocal &&
			<div>
			<div className="texto-17">
				{ !this.props.movil && !this.props.dp &&
					<p>Por tu seguridad es necesario que contestes las siguientes preguntas secretas para poder realizar la cancelación de la cuenta. Recuerda que al cancelar tu cuenta no podrás ingresar a tu sesión y deberás realizar tu registro completo nuevamente.</p>
				}
				{ this.props.movil &&
					<p>Por tu seguridad es necesario que contestes las siguientes preguntas secretas para validar tu cuenta. </p>
				}
				{ this.props.dp &&
					<p>Por seguridad es necesario que contestes las siguientes preguntas secretas para modificar tus datos. </p>
				}
			</div>
			<div className="row">
				<div className="col-xs-12 col-md-10 col-md-offset-1">
					<div className="row">
						<div className="col-xs-12 mt-50">
							<div className="input-wrap">
								<label>Pregunta secreta 1</label>
								<p>{this.props.preguntas1[this.props.preguntaUno]}</p>
							</div>
						</div>
						<div className="col-xs-12">
							<div className="input-wrap">
								<label>Respuesta</label>
								<span className={this.state.inputActive}>
									<input id="respuesta1" ref="respuesta1" type="password" onFocus={this.handleFocus} onBlur={this.handleBlur} />
									
								</span>
								{ this.state.errorPreguntaContrasena && 
                                    <div className="error-wrap">
                                        <div className="msj-error">
                                            <p>{this.state.errorMsjPreguntaContrasena}</p>
                                        </div>
                                    </div>
                                }
							</div>
						</div>
						<div className="col-xs-12 mt-50">
							<div className="input-wrap">
								<label>Pregunta secreta 2</label>
								<p>{this.props.preguntas2[this.props.preguntaDos]}</p>
							</div>
						</div>
						<div className="col-xs-12">
							<div className="input-wrap">
								<label>Respuesta</label>
								<span className={this.state.inputActive2}>
									<input id="respuesta2" ref="respuesta2" type="password" onFocus={this.handleFocus} onBlur={this.handleBlur} />
								
								</span>
								{ this.state.errorPreguntaContrasena && 
                                    <div className="error-wrap">
                                        <div className="msj-error">
                                            <p>{this.state.errorMsjPreguntaContrasena}</p>
                                        </div>
                                    </div>
                                }
							</div>
						</div>
						<div className="col-xs-12">
							<div className="text-center aceptar-cancelar-btn mt-50">
								<a onClick={this.cancelar}>Cancelar</a>
								<a onClick={this.revisarPregunta} className="orange-btn">Siguiente</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
			}
        </div>
	}
}

export default connect(mapState, mapDispatch)(PasoDosEliminarCuenta);


// WEBPACK FOOTER //
// ./src/miPerfil/pasoDosEliminarCuenta.cmpt.js